var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import IconButton from '@material-ui/core/IconButton';
import styled from 'react-emotion';
import { CustomFormikMUITextField } from '../CustomFormikMUITextField';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  ", "\n  ", "\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  ", "\n  ", "\n"])), function (props) { return (props.fullWidth ? "width: 100%" : ""); }, function (props) { return (props.half ? "width: 49.3%" : ""); });
export var NoSpinInput = styled(CustomFormikMUITextField)(function (props) { return ({
    '&&': {
        '& input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: "translate(0px, -15px) scale(0.75)"
        },
        '& .MuiOutlinedInput-input': {
            paddingRight: props.clear ? 84 : 60
        }
    }
}); });
export var HoverIconButton = styled(IconButton)(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        '&&': {
            '& :hover': {
                color: ((_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.focusColor) || '#197bdd'
            },
            padding: 0
        }
    });
});
export var IconWrapper = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  position: absolute;\n  right: 5px;\n  top: 15px;\n"], ["\n  display: flex;\n  position: absolute;\n  right: 5px;\n  top: 15px;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=CustomFormikNumberField.Styles.js.map